import { makeStyles } from "@mui/styles";

export const useStylesDatepicker = makeStyles({
  root: {
    textTransform: "capitalize! important" as "capitalize",
  },
});
